import Code from '@tiptap/extension-code'
import Color from '@tiptap/extension-color'
import Link from '@tiptap/extension-link'
import NodeRange from '@tiptap/extension-node-range'
import Placeholder from '@tiptap/extension-placeholder'
import TextStyle from '@tiptap/extension-text-style'
import StarterKit from '@tiptap/starter-kit'

import { AnnouncementCodeBlock } from './codeBlock'
import { AnnouncementFontSize } from './fontSize'
import { ListItemWithColor } from './listItemWithColor'
import { PreservedSelection } from './preservedSelection'

const AnnouncementCode = Code.extend({
  excludes: '',
})

export const createAnnouncementEditorExtensions = (placeholder?: string) => [
  StarterKit.configure({
    heading: {
      levels: [1, 2, 3, 4],
    },
    listItem: false,
    code: false,
    codeBlock: false,
  }),
  AnnouncementCodeBlock.configure({
    HTMLAttributes: {
      class: 'announcement-editor-code-block',
    },
  }),
  AnnouncementCode,
  ListItemWithColor,
  PreservedSelection,
  NodeRange,
  TextStyle,
  AnnouncementFontSize.configure({
    types: ['textStyle'],
  }),
  Color.configure({
    types: ['textStyle'],
  }),
  Link.configure({
    openOnClick: false,
    HTMLAttributes: {
      rel: 'noopener noreferrer',
      target: '_blank',
    },
  }),
  Placeholder.configure({
    placeholder: placeholder ?? '本文を入力してください',
  }),
]
